module.exports = __webpack_public_path__ + "static/media/men-ichi.6a5dd0f4.png";